<footer>
  Copyright &copy; 2023-{{ this.currentYear }} by
  <a target="_blank" href="https://code-mint.com/">CodeMint</a>
</footer>
